import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

function Question({question, answer}) {

  const [expand, setExpand] = useState(false);

  const expandClass = expand ? 'display' : 'hidden'
  const ansClass = `${expandClass} p-4`


  return (      
    <div className="shadow rounded border border-gray-100 border-t-0">
      <div className="p-4 text-xl relative">
        {question}
        <button onClick={() => setExpand(!expand)} className="text-xl absolute top-0 right-0 p-4 focus:outline-none">
          {
            expand ? 
            <FontAwesomeIcon icon={faChevronUp} size="1x" />
            :
            <FontAwesomeIcon icon={faChevronDown} size="1x" />
          }          
        </button>          
      </div>        
      <div className={ansClass}>{answer}</div>
    </div>
  )
}

export default Question;